import { LoadCurrentAccount } from '@/javascript/domain/usecases'
import { AccessDeniedError, UnexpectedError } from '@/javascript/domain/errors'
import { HttpClient, HttpStatusCode } from '../protocols/http'
import { Account } from '@/javascript/domain/entities'

export class RemoteLoadCurrentAccount implements LoadCurrentAccount {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<RemoteLoadCurrentAccount.Response>
  ) {}

  async load(): Promise<Account> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'get'
    })
    const response = httpResponse.body
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return formatResponse(response)
      case HttpStatusCode.noContent: return null
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      default: throw new UnexpectedError()
    }
  }
}

export namespace RemoteLoadCurrentAccount {
  export type RemoteAccount = {
    id: number
    address?: string
    latitude?: number
    longitude?: number
  }
  export type Response = RemoteAccount
}

const formatResponse = (response: RemoteLoadCurrentAccount.Response): Account => {
  return {
    id: response.id,
    address: response.address,
    latitude: response.latitude,
    longitude: response.longitude
  }
}
